import _ from 'lodash';
import monarch from '../clients/monarch';

const DEFAULT_REGION_LABEL = 'Loading...';
const DEFAULT = 'Default';

export function codeToRegion(code) {
  return monarch
    .get(`/v1/locations?codes=${code}`)
    .then((response) => response.data[0]);
}

export function formatRegionLabel(region) {
  if (!region) {
    return DEFAULT_REGION_LABEL;
  } else if (region.province) {
    return (
      region.name +
      ', ' +
      region.province.name +
      ', ' +
      region.province.country.name
    );
  } else if (region.country) {
    return region.name + ', ' + region.country.name;
  } else {
    return region.name;
  }
}

export function formatRegionLabelByParent(region, parent) {
  if (!region) {
    return DEFAULT_REGION_LABEL;
  } else if (region.province && parent && !parent.country) {
    return region.name + ', ' + region.province.name;
  } else {
    return region.name;
  }
}

export function reverseFormatRegionLabel(region) {
  if (!region) {
    return DEFAULT_REGION_LABEL;
  } else if (region.province) {
    return (
      region.province.country.name +
      ', ' +
      region.province.name +
      ', ' +
      region.name
    );
  } else if (region.country) {
    return region.country.name + ', ' + region.name;
  } else {
    return region.name;
  }
}

export function formatTerritories(territories, regions, id) {
  let data = {};
  let validTerritoriesMap = createKeyMap(territories, regions);

  validTerritoriesMap = _.values(validTerritoriesMap);

  validTerritoriesMap.map((country) => {
    let countryFromSource = _.find(
      territories,
      (terr) => terr.code === country.code,
    );
    country.deliveryOptions =
      countryFromSource && countryFromSource.deliveryOptions;

    if (!_.isEmpty(country.subdivisions)) {
      country.subdivisions = _.values(country.subdivisions);
      country.subdivisions.map((subdivision) => {
        let subdivisionFromSource = _.find(
          territories,
          (terr) => terr.code === subdivision.code,
        );
        subdivision.deliveryOptions =
          subdivisionFromSource && subdivisionFromSource.deliveryOptions;
        if (!_.isEmpty(subdivision.subdivisions)) {
          subdivision.subdivisions.map((city) => {
            let cityFromSource = _.find(
              territories,
              (terr) => terr.code === city.code,
            );
            city.deliveryOptions =
              cityFromSource && cityFromSource.deliveryOptions;
          });
        }
      });
    } else {
      _.unset(country, 'subdivisions');
    }
  });

  validTerritoriesMap = _.compact(validTerritoriesMap);
  validTerritoriesMap.length > 0
    ? _.assignIn(data, { validIn: { countries: validTerritoriesMap }, id })
    : null;

  let exceptions = [];

  territories.map((territory) => {
    territory.excludeCodes.map((excludeCode) => {
      exceptions.push({ code: excludeCode });
    });
  });

  let invalidTerritoriesMap = createKeyMap(exceptions, regions);
  invalidTerritoriesMap = _.values(invalidTerritoriesMap);

  invalidTerritoriesMap.map((country) => {
    if (!_.isEmpty(country.subdivisions)) {
      country.subdivisions = _.values(country.subdivisions);
    } else {
      _.unset(country, 'subdivisions');
    }
  });

  invalidTerritoriesMap = _.compact(invalidTerritoriesMap);
  invalidTerritoriesMap.length > 0
    ? _.assignIn(data, { notValidIn: { countries: invalidTerritoriesMap }, id })
    : null;

  return data;
}

function createKeyMap(territories, regions) {
  let territoriesMap = {};

  territories.forEach((territory) => {
    let region = regions[territory.code];

    if (region.type === DEFAULT) {
      return null;
    }
    if (region.country) {
      if (
        territoriesMap[region.country.code] &&
        territoriesMap[region.country.code]['subdivisions'][region.code]
      ) {
        return null;
      } else if (territoriesMap[region.country.code]) {
        let province = {};

        province['code'] = region.code;
        province['name'] = region.name;
        //province['subdivisions'] = []
        territoriesMap[region.country.code]['subdivisions'][region.code] =
          province;
      } else {
        let country = {};

        country['code'] = region.country.code;
        country['name'] = region.country.name;
        country['subdivisions'] = {};

        let province = {};

        province['code'] = region.code;
        province['name'] = region.name;
        // province['subdivisions'] = []
        country['subdivisions'][region.code] = province;

        territoriesMap[region.country.code] = country;
      }
    } else if (region.province) {
      if (
        territoriesMap[region.province.country.code] &&
        territoriesMap[region.province.country.code]['subdivisions'][
          region.province.code
        ]
      ) {
        let city = {};

        city['code'] = region.code;
        city['name'] = region.name;
        //territoriesMap[region.province.country.code]['subdivisions'][region.province.code]['subdivisions'].push(city)
        territoriesMap[region.province.country.code]['subdivisions'][
          region.province.code
        ]['subdivisions']
          ? territoriesMap[region.province.country.code]['subdivisions'][
              region.province.code
            ]['subdivisions'].push(city)
          : (territoriesMap[region.province.country.code]['subdivisions'][
              region.province.code
            ]['subdivisions'] = [city]);
      } else if (territoriesMap[region.province.country.code]) {
        let province = {};

        province['code'] = region.province.code;
        province['name'] = region.province.name;
        // province['subdivisions'] = []

        let city = {};

        city['code'] = region.code;
        city['name'] = region.name;
        province['subdivisions'] = [city];

        territoriesMap[region.province.country.code]['subdivisions'][
          region.province.code
        ] = province;
      } else {
        let city = {};

        city['code'] = region.code;
        city['name'] = region.name;

        let province = {};

        province['code'] = region.province.code;
        province['name'] = region.province.name;
        province['subdivisions'] = [city];

        let country = {};

        country['code'] = region.province.country.code;
        country['name'] = region.province.country.name;
        country['subdivisions'] = {};
        country['subdivisions'][region.province.code] = province;

        territoriesMap[region.province.country.code] = country;
      }
    } else {
      if (territoriesMap[region.code]) {
        return;
      } else {
        let country = {};

        country['code'] = region.code;
        country['name'] = region.name;
        country['subdivisions'] = {};

        territoriesMap[region.code] = country;
      }
    }
  });

  return territoriesMap;
}

export function constructServiceAreasFromTrex(serviceLocations) {
  let serviceAreas = [];
  serviceLocations.forEach((serviceLocation) => {
    serviceAreas.push(_constructServiceLocationFromTrex(serviceLocation));
  });

  return _.flatten(serviceAreas);
}

function _constructServiceLocationFromTrex(trex) {
  let serviceLocations = [];

  if (trex.validIn && trex.validIn && trex.validIn.countries) {
    trex.validIn &&
      trex.validIn.countries.map((country) => {
        if (!_.isEmpty(country.deliveryOptions)) {
          serviceLocations.push({
            code: country.code,
            deliveryOptions: country.deliveryOptions,
            excludeCodes: [],
            status: country.status,
            id: country.id,
            deliveryType: country.deliveryType,
          });
        }
        country.subdivisions &&
          country.subdivisions.map((province) => {
            if (!_.isEmpty(province.deliveryOptions)) {
              serviceLocations.push({
                code: province.code,
                deliveryOptions: province.deliveryOptions,
                excludeCodes: [],
                status: province.status,
                id: province.id,
                deliveryType: province.deliveryType,
              });
            }
            province.subdivisions &&
              province.subdivisions.map((city) => {
                if (!_.isEmpty(city.deliveryOptions)) {
                  serviceLocations.push({
                    code: city.code,
                    deliveryOptions: city.deliveryOptions,
                    excludeCodes: [],
                    status: city.status,
                    id: city.id,
                    deliveryType: city.deliveryType,
                  });
                }
              });
          });
      });
  }

  trex.notValidIn &&
    trex.notValidIn.countries.map((country) => {
      if (_.isEmpty(country.subdivisions)) {
        serviceLocations[0].excludeCodes.push(country.code);
      } else {
        country.subdivisions.map((province) => {
          if (_.isEmpty(province.subdivisions)) {
            let parentCountry = serviceLocations.find((serviceArea) => {
              return serviceArea.code === country.code;
            });
            if (!_.isEmpty(parentCountry)) {
              parentCountry.excludeCodes.push(province.code);
            }
          } else {
            province.subdivisions.map((city) => {
              let parentProvince = serviceLocations.find((serviceArea) => {
                return serviceArea.code === province.code;
              });
              let parentCountry = serviceLocations.find((serviceArea) => {
                return serviceArea.code === country.code;
              });
              if (!_.isEmpty(parentProvince)) {
                parentProvince.excludeCodes.push(city.code);
              } else if (!_.isEmpty(parentCountry)) {
                parentCountry.excludeCodes.push(city.code);
              }
            });
          }
        });
      }
    });

  return serviceLocations;
}
